var map = {
	"./tab1_1.png": 873,
	"./tab1_2.png": 874,
	"./tab2_1.png": 875,
	"./tab2_2.png": 876,
	"./tab2_3.png": 877,
	"./tab3_1.png": 878,
	"./tab3_2.png": 879
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1381;